import template from './view.html';
import * as AccountsActions from '../../../state/accounts/accounts.actions';
import Auth from '../../../auth';

export class SubAccountViewController {
  constructor($ngRedux) {
    'ngInject';

    this.store = $ngRedux;
    this.mapStateToThis = this.mapStateToThis.bind(this);
    this.unsubscribe = this.store.connect(this.mapStateToThis, this.mapDispatchToTarget)(this);
    this.editingName = false;
  }

  $onDestroy() {
    this.unsubscribe();
  }

  mapStateToThis(state) {
    let selectedRoles = state.accounts.account_roles;

    if (state.accounts.viewing_account) {
      let inheritedRoles = state.accounts.viewing_account.inheritedRoles.map((role) => role.id);

      selectedRoles = state.accounts.account_roles.map((role) => {
        role.selected = inheritedRoles.includes(role.id);
        return role;
      });
    }

    return {
      updating: state.accounts.updating_subaccount,
      account: { ...state.accounts.viewing_account },
      editingAccount: { ...state.accounts.viewing_account },
      roles: selectedRoles,
    };
  }

  goToAccount(account) {
    Auth.switchAccount(account.id);
  }

  mapDispatchToTarget(dispatch) {
    return {
      updateSubAccount: (props) => dispatch(AccountsActions.updateSubAccount(props)),
      updateInheritedRoles: (account, roles) =>
        dispatch(AccountsActions.updateInheritedRoles(account, roles)),
    };
  }

  updateSubAccountName() {
    if (this.editingAccount.name) {
      this.updateSubAccount({ ...this.account, name: this.editingAccount.name });
      this.editingName = false;
    }
  }

  editName() {
    this.editingName = true;
  }

  nameChanged() {
    window.dataLayer.push({
      event: 'subaccountNameChanged',
    });
  }

  cancelEditName() {
    this.editingName = false;
  }

  updateRoles() {
    let roles = [...this.roles];

    let rolesToUpdate = roles
      .filter((role) => role.selected)
      .map((role) => {
        delete role.selected;
        return role;
      });

    this.updateInheritedRoles(this.account, rolesToUpdate);
    window.dataLayer.push({
      event: 'subaccountRolesUpdated',
      data: {
        total: roles.length,
        totalSelected: rolesToUpdate.length,
      },
    });
  }
}

export default {
  template,
  replace: true,
  bindings: {
    account: '<',
  },
  controller: SubAccountViewController,
  controllerAs: 'vm',
};
